module.exports = __webpack_public_path__ + "img/stop_btn.2eacd471.png";